import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal, 
} from "reactstrap"
import { Link } from "react-router-dom"

import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';

import { get, post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import cogoToast from 'cogo-toast';

import moment from 'moment';

const UnplannedTask = props => {

  const [loading, setLoading] = React.useState(true);
  const [errors, setErrors] = React.useState([]);
  const [editing, setEditing] = React.useState(false);
  const [data, setData] = React.useState(null);
  const [origData, setOrigData] = React.useState(null);

  const [workorderId, setWorkorderId] = React.useState(null);

  
  const fetchData = () => {
    setLoading(true);
    get(url.GET_UNPLANNED_TASK+'/'+props.id).then(response => {
      console.log('RESP', response.data);
      if (response.status == 200) {
        let resData = response.data;
        // if(resData.ppmchecklist) {
        //   resData.ppmchecklist.data = JSON.parse(resData.ppmchecklist.data);
        // }
        // if(resData.checklist) {
        //   resData.checklist.data = JSON.parse(resData.checklist.data);
        // }
        setData(resData);
        setOrigData(resData);
        setLoading(false);
      }
      else {
        setData(null);
        setLoading(false);
      }
    })
      .catch(error => {
        console.log('err:', error);
      });
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  // console.log(data);



  const handleSubmit = () => {

    // console.log('data', data);

    // TODO : Validations / epmty checks / mandatory fields

    // if(!frequencies[i].assets || frequencies[i].assets.length < 1) {
    //   cogoToast.error('Please choose assets for frequency '+(i+1));
    //   return;
    // }

    let formData = {
      id: props.mode == 'ppm' ? data.ppmchecklist.id : data.checklist.id,
      data: props.mode == 'ppm' ? JSON.stringify(data.ppmchecklist.data) : JSON.stringify(data.checklist.data),
      mode: props.mode,
      remarks: data.remarks,
    };
    

    console.log('data', formData);
    
    setLoading(true);
    setErrors([]);
    post(url.POST_EDIT_CHECKLIST, formData)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        cogoToast.success('Checklist updated successfully');
        setEditing(false);
        fetchData();
      }
      else if(response.status == 400) {
        // setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };

  return (
    <Modal
        isOpen={true}
        size="xl"
        toggle={() => {
          // tog_scroll()
        }}
        scrollable={true}
      >

        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {props.mode == 'ppm' && 'PPM '}Unplanned Task Details
          </h5>
          <button
            type="button"
            onClick={() => {
              props.setUnplannedTaskId(null);
            }
            }
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {data == null ? 
          <div className="text-muted">Could not load task details</div> :
          <div>
            <div className="row mb-4">
              <div className="col">
                <div className="fw-medium">Asset Name</div>
                <div>{data.asset && data.asset.name}</div>
              </div>
              <div className="col">
                <div className="fw-medium">Form Name</div>
                <div>{data.form && data.form.name}</div>
              </div>
              {/* <div className="col">
                <div className="fw-medium">Status</div>
                <div>
                </div>
              </div> */}
            </div>
            <div className="row mb-4">
              {/* <div className="col">
                <div className="fw-medium">Scheduled Date</div>
                <div>
                  <div>{moment(data.task_date).format('DD MMM YYYY')}</div>
                </div>
              </div> */}
              <div className="col">
                <div className="fw-medium">Done by</div>
                <div>{data.user && data.user.name}</div>
                <div>{data.groups && data.groups.map(g => g.name).join(', ')}</div>
              </div>
              <div className="col">
                <div className="fw-medium">Done at</div>
                 <div>{moment(data.started_at).format('DD MMM YYYY hh:mm a')} to</div>
                  <div>{moment(data.ended_at).format('DD MMM YYYY hh:mm a')}</div>
              </div>
            </div>


            <h5 className="h5 mt-5 mb-3">Checklist</h5>
              <div>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Parameter</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.mode == 'ppm' && data && data.ppmchecklist && data.ppmchecklist.data &&
                    data.ppmchecklist.data.map((citem, citemIdx)=>(
                      <tr key={citemIdx}>
                        <td width="50%">
                          <div className="formfield-display">
                            {citem.label}
                          </div>
                        </td>
                        <td width="50%">
                          {editing ?
                          <div className="formfield-editing">
                            {citem.type == 'number' ?
                              <input type="number" className="form-control" value={citem.val} 
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.ppmchecklist.data[citemIdx].val = e.target.value;
                                  setData(temp);
                                }}
                                />
                              :
                              (citem.type == 'radio' ?
                              <select className="form-control" value={citem.val}
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.ppmchecklist.data[citemIdx].val = e.target.value;
                                  setData(temp);
                                }}
                                >
                                {(citem.options?.split(',')).map((cOpt, cOptIdx)=>(
                                  <option key={cOptIdx} val={cOpt}>{cOpt}</option>
                                ))}
                              </select>
                                :
                                <input type="text" className="form-control" value={citem.val} 
                                  onChange={(e)=>{
                                    let temp = JSON.parse(JSON.stringify(data));
                                    temp.ppmchecklist.data[citemIdx].val = e.target.value;
                                    setData(temp);
                                  }}
                                  />)
                            }
                          </div>
                          :
                          <div className="formfield-display">{citem.val}</div>
                          }
                        </td>
                      </tr>
                    ))}

                    {data && 
                      JSON.parse(data.data).map((citem, citemIdx)=>(
                      <tr key={citemIdx}>
                        <td width="50%">
                          <div className="formfield-display">
                            {citem.label}
                          </div>
                        </td>
                        <td width="50%">
                          {editing ?
                          <div className="formfield-editing">
                            {citem.type == 'number' ?
                              <input type="number" className="form-control" value={citem.val} 
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.data[citemIdx].val = e.target.value;
                                  setData(temp);
                                }}
                                />
                              :
                              (citem.type == 'radio' ?
                              <select className="form-control" value={citem.val}
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.data[citemIdx].val = e.target.value;
                                  setData(temp);
                                }}
                                >
                                {(citem.options?.split(',')).map((cOpt, cOptIdx)=>(
                                  <option key={cOptIdx} val={cOpt}>{cOpt}</option>
                                ))}
                              </select>
                                :
                                <input type="text" className="form-control" value={citem.val} 
                                  onChange={(e)=>{
                                    let temp = JSON.parse(JSON.stringify(data));
                                    temp.data[citemIdx].val = e.target.value;
                                    setData(temp);
                                  }}
                                  />)
                            }
                          </div>
                          :
                          <div className="formfield-display">{citem.val}</div>
                          }
                        </td>
                      </tr>
                    ))}

                      <tr>
                        <td width="50%">
                          <div className="formfield-display">
                            Remarks
                          </div>
                        </td>
                        <td width="50%">
                          {editing ?
                          <div className="formfield-editing">
                            {
                              <input type="text" className="form-control" value={data.remarks} 
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.remarks = e.target.value;
                                  setData(temp);
                                }}
                                />
                            }
                          </div>
                          :
                          <div className="formfield-display">{data.remarks}</div>
                          }
                        </td>
                      </tr>

                  </tbody>
                </table>
              </div>

            {/* { 
            ((props.mode == 'ppm' && data && data.ppmchecklist?.ppmchecklistlogs.length > 0) ||
              (props.mode !== 'ppm' && data && data.checklist?.checklistlogs.length > 0)
              ) &&
            <div>
              <h5 className="h5 mt-5 mb-3">Edit History</h5>
              <div>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Edited at</th>
                    </tr>
                  </thead>
                  <tbody>
                    { props.mode == 'ppm' ?
                    data.ppmchecklist?.ppmchecklistlogs.map((logItem, logIdx)=>(
                      <tr key={logIdx}>
                        <td>Admin</td>
                        <td>{moment(logItem.created_at).format('DD MMM YYYY hh:mm a')}</td>
                      </tr>
                    )) :
                    data.checklist?.checklistlogs.map((logItem, logIdx)=>(
                      <tr key={logIdx}>
                        <td>Admin</td>
                        <td>{moment(logItem.created_at).format('DD MMM YYYY hh:mm a')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            }
            {((props.mode == 'ppm' && data && data.ppmchecklist) || (props.mode !== 'ppm' && data && data.checklist)) &&
            <div className="mt-3">
              { ((props.mode == 'ppm' && data && data.ppmchecklist?.ppmchecklistimages.length > 0) || (props.mode !== 'ppm' && data && data.checklist.checklistimages.length > 0)) &&
              <div>
                <h5 className="h5 mt-5 mb-3">Images</h5>
                <div>
                  { props.mode == 'ppm' ?
                  data.ppmchecklist?.ppmchecklistimages.map((cImg, cIdx)=>(
                    <img key={cIdx} className="checklist-img" src={"https://apilogbook.six30labs.com/storage/checklistimages/"+cImg.filename} />
                  )) :
                  data.checklist.checklistimages.map((cImg, cIdx)=>(
                    <img key={cIdx} className="checklist-img" src={"https://apilogbook.six30labs.com/storage/checklistimages/"+cImg.filename} />
                  ))}
                </div>
              </div>
              }
              <h5 className="h5 mt-5 mb-3">Checklist</h5>
              <div>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Parameter</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.mode == 'ppm' && data && data.ppmchecklist && data.ppmchecklist.data &&
                    data.ppmchecklist.data.map((citem, citemIdx)=>(
                      <tr key={citemIdx}>
                        <td width="50%">
                          <div className="formfield-display">
                            {citem.label}
                          </div>
                        </td>
                        <td width="50%">
                          {editing ?
                          <div className="formfield-editing">
                            {citem.type == 'number' ?
                              <input type="number" className="form-control" value={citem.val} 
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.ppmchecklist.data[citemIdx].val = e.target.value;
                                  setData(temp);
                                }}
                                />
                              :
                              (citem.type == 'radio' ?
                              <select className="form-control" value={citem.val}
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.ppmchecklist.data[citemIdx].val = e.target.value;
                                  setData(temp);
                                }}
                                >
                                {(citem.options?.split(',')).map((cOpt, cOptIdx)=>(
                                  <option key={cOptIdx} val={cOpt}>{cOpt}</option>
                                ))}
                              </select>
                                :
                                <input type="text" className="form-control" value={citem.val} 
                                  onChange={(e)=>{
                                    let temp = JSON.parse(JSON.stringify(data));
                                    temp.ppmchecklist.data[citemIdx].val = e.target.value;
                                    setData(temp);
                                  }}
                                  />)
                            }
                          </div>
                          :
                          <div className="formfield-display">{citem.val}</div>
                          }
                        </td>
                      </tr>
                    ))}

                    {props.mode !== 'ppm' && data && data.checklist &&
                      data.checklist.data.map((citem, citemIdx)=>(
                      <tr key={citemIdx}>
                        <td width="50%">
                          <div className="formfield-display">
                            {citem.label}
                          </div>
                        </td>
                        <td width="50%">
                          {editing ?
                          <div className="formfield-editing">
                            {citem.type == 'number' ?
                              <input type="number" className="form-control" value={citem.val} 
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.checklist.data[citemIdx].val = e.target.value;
                                  setData(temp);
                                }}
                                />
                              :
                              (citem.type == 'radio' ?
                              <select className="form-control" value={citem.val}
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.checklist.data[citemIdx].val = e.target.value;
                                  setData(temp);
                                }}
                                >
                                {(citem.options?.split(',')).map((cOpt, cOptIdx)=>(
                                  <option key={cOptIdx} val={cOpt}>{cOpt}</option>
                                ))}
                              </select>
                                :
                                <input type="text" className="form-control" value={citem.val} 
                                  onChange={(e)=>{
                                    let temp = JSON.parse(JSON.stringify(data));
                                    temp.checklist.data[citemIdx].val = e.target.value;
                                    setData(temp);
                                  }}
                                  />)
                            }
                          </div>
                          :
                          <div className="formfield-display">{citem.val}</div>
                          }
                        </td>
                      </tr>
                    ))}

                      <tr>
                        <td width="50%">
                          <div className="formfield-display">
                            Remarks
                          </div>
                        </td>
                        <td width="50%">
                          {editing ?
                          <div className="formfield-editing">
                            {
                              <input type="text" className="form-control" value={data.remarks} 
                                onChange={(e)=>{
                                  let temp = JSON.parse(JSON.stringify(data));
                                  temp.remarks = e.target.value;
                                  setData(temp);
                                }}
                                />
                            }
                          </div>
                          :
                          <div className="formfield-display">{data.remarks}</div>
                          }
                        </td>
                      </tr>

                  </tbody>
                </table>
              </div>
            </div>
            } */}
          </div>
          }
          <div className="modal-footer">
            { editing &&
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() =>{
                let te = JSON.parse(JSON.stringify(origData));
                setData(te);
              }
              }
            >
              Reset
            </button>}
            { editing &&
            <button
              type="button"
              className="btn btn-primary"
              onClick={() =>{ 
                handleSubmit(); 
              }}
            >
              Submit
            </button>}
            { ((props.mode == 'ppm' && data && data.ppmchecklist) || (props.mode !== 'ppm' && data && data.checklist)) &&
            <button type="button" className={editing ? "btn btn-secondary" : "btn btn-primary"}
              onClick={()=>{ 
                if(editing) {
                  let te = JSON.parse(JSON.stringify(origData));
                  setData(te);
                }
                setEditing(!editing); 
              }}
              >
              {editing ? 'Cancel' : 'Edit'}
            </button>}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() =>{
                props.setUnplannedTaskId(null);
              }
              }
            >
              Close
                </button>
          </div>
        </div>
      </Modal>
  )
}

export default UnplannedTask




